<template>
  <component
    :is="url ? 'a' : 'div'"
    class="payment-method-row"
    :class="{ 'payment-method-row--clickable': !!url }"
    :href="url || undefined"
    :target="url ? '_blank' : undefined"
    :rel="url ? 'noopener noreferrer' : undefined"
  >
    <div class="pm-icon" :style="iconStyle">
      <slot name="icon" />
    </div>
    <div class="pm-info">
      <component
        :is="url ? 'a' : 'span'"
        class="pm-name"
        :href="url || undefined"
        :target="url ? '_blank' : undefined"
        :rel="url ? 'noopener noreferrer' : undefined"
        @click.stop
        >{{ name }}</component
      >
      <div class="pm-desc">{{ description }}</div>
    </div>
    <span :class="badgeClass">{{ badgeText }}</span>
  </component>
</template>

<script>
export default {
  name: "PaymentMethodRow",
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    badgeType: {
      type: String,
      default: "instant",
      validator: (v) => ["instant", "bnpl"].includes(v),
    },
    badgeText: {
      type: String,
      default: "Instant",
    },
    iconStyle: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
  },
  computed: {
    badgeClass() {
      return `pm-badge pm-badge-${this.badgeType}`;
    },
  },
};
</script>
